import * as CartState from '@dav-store/cart/cart.reducer';
import * as UserState from '@dav-store/user/user.reducer';
import * as VehicleState from '@dav-store/vehicle/vehicle.reducer';

import { GetProductsRequest } from '../request/product.request';

export class SaveQuote {
    VehicleState: VehicleState.State;
    cartState: CartState.State;
    userState: UserState.State;
    getProductRequest: GetProductsRequest;

    constructor(getProductsRequest: GetProductsRequest, vehicleState: VehicleState.State,
        cartState: CartState.State, userState: UserState.State) {
        this.userState = userState;
        this.VehicleState = vehicleState;
        this.cartState = cartState;
        this.getProductRequest = getProductsRequest;
    }
}

